define(function (require, exports, module) {
    var priceModel = require("../../model/priceModel/priceModel");

    var price = {
        skuArry: [],
        pageNum: 40,
        timeNow: null,
        init: function (tag) {
            var self = this;
            tag = tag || "";

            if ($("#priceQuerySwitch").val() == "ON") {
                self.getPrice(tag);
            }
        },
        unique: function (arr) {
            var result = [], hash = {};
            for (var i = 0, elem; (elem = arr[i]) != null; i++) {
                if (!hash[elem]) {
                    result.push(elem);
                    hash[elem] = true;
                }
            }
            return result;
        },
        getPrice: function (tag) {
            var self = this;
            var skuList = "";
            self.skuArry = [];
            //所有的skuid
            $("[skuid]").each(function () {
                if (!$(this).hasClass("priceLoad")) {
                    skuList = skuList + "," + $(this).attr("skuid");
                }
            });

            skuList = skuList.substring(1, skuList.length);
            skuList = skuList.split(",");

            skuList = self.unique(skuList);

            var num = Math.ceil(skuList.length / self.pageNum);

            for (var i = 1; i <= num; i++) {
                var skuids = "";
                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
                    if (typeof(skuList[j]) != "undefined") {
                        skuids = skuids + "," + skuList[j];
                    } else {
                        continue;
                    }
                }
                skuids = skuids.substring(1, skuids.length);

                if (skuids != "") {
                    self.skuArry.push(skuids);
                }
            }

            if (self.skuArry.length == 0) {
                return false;
            }
            for (var i = 0; i < self.skuArry.length; i++) {
                if (tag == "seckill") {
                    self.ajaxSecKillPrice(self.skuArry[i]);
                } else if (tag == "pcpPrice") {
                    self.ajaxPcpPrice(self.skuArry[i]);
                } else {
                    self.ajaxPrice(self.skuArry[i]);
                }
            }
        },
        ajaxPrice: function (skuids) {
            var self = this;
            var arg = {
                "skuids": skuids,
                "origin": 2,
                "source": "globalbuy"
            };
            var skuArray = skuids.split(',');
            var leftSkuArray = skuArray.slice();

            priceModel.ajaxGetPrice(arg, function (data) {
                var length = skuArray.length;
                for (var i = 0; i < length; i++) {
                    var element = skuArray[i];
                    $.each(data, function () {
                        /**
                         ** this.id是调用接口返回的skuid
                         ** element是页面上的skuid
                         ** thisObj是根据页面上的skuid找到的节点
                         **/
                        var newPrice = priceModel.formatPrice(this.p);
                        var oldPrice = priceModel.formatPrice(this.m);

                        var samPrice = null;
                        if (this.sp) {
                            samPrice = priceModel.formatPrice(this.sp);
                        }

                        var thisObj = $("[skuid='" + element + "']");

                        thisObj.addClass("priceLoad");

                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
                            thisObj.find(".price span").text("¥" + newPrice);
                            thisObj.find(".price del").text("¥" + oldPrice);

                            var samDiv = thisObj.find(".sam");
                            if (samDiv.length > 0 && samPrice !== null) {
                                samDiv.html(`
                                    <div class="p-sam">&yen;${samPrice}</div>
                                    <i class="logo"></i>
                                `);
                            }

                            var discount = priceModel.getDiscount(newPrice, oldPrice);
                            if (discount != "") {
                                thisObj.find(".discount").text(discount + "折");
                            } else {
                                thisObj.find(".discount").remove();
                            }
                            var ind = leftSkuArray.indexOf(element);
                            if (ind >= 0) {
                                leftSkuArray.splice(ind, 1);
                            }
                            return;
                        }
                    });
                }
                ;

                if (leftSkuArray.length > 0) {
                    leftSkuArray.forEach(function (element, _index) {
                        var thisObj = $("[skuid='" + element + "']");
                        thisObj.find(".price span").text("暂无价格").css({
                            "font-size": ".6rem"
                        });
                        thisObj.find(".discount").remove();
                        if (thisObj.find("em")) {
                            thisObj.find("em").remove();
                        }
                        return;
                    })
                }
            });
        },
        ajaxSecKillPrice: function (skuids) {
            var self = this;
            var arg = {
                "skuids": skuids,
                "origin": 2,
                "source": "globalbuy"
            };
            var skuArray = skuids.split(',');
            var leftSkuArray = skuArray.slice();

            priceModel.ajaxGetPrice(arg, function (data) {
                var skuArray = skuids.split(",");
                var cbData = [];
                var existedArray = [];
                $(data).each(function () {
                    cbData.push(this.id);
                });

                for (var i = 0; i < skuArray.length; i++) {
                    var skuid = skuArray[i];
                    if (existedArray.indexOf(skuid) > -1) {
                        continue;
                    }
                    existedArray.push(skuid);

                    var num = cbData.indexOf(skuid);

                    if (num > -1) {
                        var skuObj = $("dd[skuid='" + skuid + "']");

                        var newPrice = priceModel.formatPrice(data[num].p);
                        var oldPrice = priceModel.formatPrice(data[num].m);

                        skuObj.each(function () {
                            var _this = $(this);
                            if (_this.parents(".tabCnt").attr("id") == "begining") {
                                if (newPrice == "-1") {
                                    _this.find(".price span").text("暂无价格").css({
                                        "font-size": ".6rem"
                                    });
                                    _this.find(".discount").remove();
                                    if (_this.find("em")) {
                                        _this.find("em").remove();
                                    }
                                    return true;
                                } else {
                                    _this.find(".price span").text("¥" + newPrice);
                                }
                            } else {
                                if (newPrice == "-1") {
                                    _this.find(".price span").text("暂无价格").css({
                                        "font-size": ".6rem"
                                    });
                                    _this.find(".discount").remove();
                                    if (_this.find("em")) {
                                        _this.find("em").remove();
                                    }
                                    return true;
                                } else if (newPrice.length == 1) {
                                    _this.find(".price span").text("¥?");
                                } else {
                                    _this.find(".price span").text("¥?" + newPrice.substring(1, newPrice.length));
                                }
                            }

                            _this.find("del").text("¥" + oldPrice).before($("<em>参考价:</em>"));

                            var discount = priceModel.getDiscount(newPrice, oldPrice);
                            if (discount != "") {
                                _this.find(".discount").text(discount + "折");
                            } else {
                                _this.find(".discount").remove();
                            }
                        });
                    }
                }
            });
        },
        ajaxPcpPrice: function (skuids) {
            var self = this;
            var arg = {
                "skuids": skuids,
                "origin": 2,
                "source": "globalbuy"
            };
            var skuArray = skuids.split(',');
            var leftSkuArray = skuArray.slice();

            priceModel.ajaxGetPcpPrice(arg, function (data) {
                var length = skuArray.length;
                for (var i = 0; i < length; i++) {
                    var element = skuArray[i];
                    $.each(data, function () {
                        /**
                         ** this.id是调用接口返回的skuid
                         ** element是页面上的skuid
                         ** thisObj是根据页面上的skuid找到的节点
                         **/
                        var newPrice = priceModel.formatPrice(this.p);
                        var oldPrice = priceModel.formatPrice(this.m);
                        var pcpPrice = priceModel.formatPrice(this.pcp);

                        var cheaper = -1;

                        //console.log('newPrice: ', newPrice, 'oldPrice:', oldPrice, 'pcpPrice:', pcpPrice);

                        var thisObj = $("[skuid='" + element + "']");

                        thisObj.addClass("priceLoad");

                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
                            thisObj.find(".price span").text("¥" + newPrice);
                            thisObj.find(".price del").text("¥" + oldPrice);

                            var discount = priceModel.getDiscount(newPrice, oldPrice);
                            if (discount != "") {
                                thisObj.find(".discount").text(discount + "折");
                            } else {
                                thisObj.find(".discount").remove();
                            }
                            var ind = leftSkuArray.indexOf(element);
                            if (ind >= 0) {
                                leftSkuArray.splice(ind, 1);
                            }

                            if (pcpPrice > 0) {
                                cheaper = pcpPrice - newPrice;
                            }

                            if (cheaper.toString().length > 2 && cheaper % 1 !== 0) {
                                cheaper = parseInt(cheaper.toFixed(2));
                            }
                            if (cheaper > 0) {
                                thisObj.find('.compare .num').html(cheaper);
                                thisObj.find('.compare').removeClass('hide');
                            }
                            //设置背景颜色
                            if ($('#background').val()) {
                                thisObj.find('.compare').css('background-color', $('#background').val());
                                thisObj.find(".price span").css('color', $('#background').val());
                            }

                            return;
                        }
                    });
                }
                ;

                if (leftSkuArray.length > 0) {
                    leftSkuArray.forEach(function (element, _index) {
                        var thisObj = $("[skuid='" + element + "']");
                        thisObj.find(".price span").text("暂无价格").css({
                            "font-size": ".6rem"
                        });
                        if ($('#background').val()) {
                            thisObj.find(".price span").css('color', $('#background').val());
                        }
                        thisObj.find(".discount").remove();
                        if (thisObj.find("em")) {
                            thisObj.find("em").remove();
                        }
                        return;
                    })
                }
            });
        }
    };
    exports.fn = price;
});



// WEBPACK FOOTER //
// ./src/js/unit/price/price.js